import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const virginiaParkConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Virginia Park Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Virginia Park, FL. Sam\'s Tree Service handles dangerous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_virginia_park',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Virginia Park',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Virginia Park Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we bring expert tree care to the 
     charming, tree shaded streets of <strong>Virginia Park</strong>. This 
     beloved South Tampa neighborhood is known for its beautiful bungalows 
     and classic Florida character and the grand old trees that frame it. 
     But those same trees need professional management as they age. Overhanging 
     limbs, storm damage, and canopy overgrowth near historic homes all require 
     skilled, careful handling.`,

    `We specialize in <strong>precision tree removal and trimming on historic 
     and character residential properties</strong> large limb work near 
     bungalows and older structures, storm split canopies, trees with aging 
     root systems near foundations and driveways, and full removals executed 
     with respect for your landscape and neighbors. We protect your property 
     start to finish.`,

    `<strong>Sam's Tree Service</strong> provides reliable, professional tree care 
     throughout <strong>Virginia Park</strong> and the surrounding 
     <strong>South Tampa</strong> neighborhoods keeping your home safe 
     and your neighborhood's character intact all year long.`,
  ],
  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Virginia Park, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_VirginiaPark = () => <LocationPage config={virginiaParkConfig} />;
export default Services_VirginiaPark;
